
  import '@webcomponents/scoped-custom-element-registry';
  (async function () {
    await import('https://omicronenergyoss.github.io/oscd-shell/oscd-shell.js');

    const oscdShell = document.querySelector('oscd-shell');
    const params = new URL(document.location).searchParams;
    for (const [name, value] of params) {
      oscdShell.setAttribute(name, value);
    }

    const filename = 'sample.scd';
    const sample = await fetch(filename).then(r => r.text());
    oscdShell.docs = {
      [filename]: new DOMParser().parseFromString(sample, 'application/xml'),
    };
    oscdShell.docName = filename;

    const { plugins } = await import('./plugins.js');
    oscdShell.plugins = plugins;
  })();
